<template>
  <DataListStateful
    title="Модели(ТМ)"
    resource="trademark-models"
    store="trademarkModels"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "TM",
          name: "trademark",
          dataPath: "Trademark.Title",
          sortable: true,
        },
        {
          title: "Производитель",
          name: "manufacturer",
          dataPath: "Manufacturer.Title",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Сайт продукта",
          name: "productSite",
          sortable: false,
          width: 100,
          maxLength: 20,
        },
        {
          title: "Категория",
          name: "productCategory",
          dataPath: "ProductCategory.Title",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Номенклатура",
          name: "nomenclature",
          dataPath: "Nomenclature.Title",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Страна происхождения",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        {
          title: "Единица измерения",
          name: "unit",
          dataPath: "Unit.Title",
          sortable: true,
        },
        { title: "Вес нетто", name: "weightNetto", sortable: false },
        { title: "Вес брутто", name: "weightBrutto", sortable: false },
        {
          title: "Материал",
          name: "material",
          sortable: false,
          width: 100,
          maxLength: 10,
        },
        { title: "Размеры", name: "dimensions", sortable: false },
        { title: "Дата создания", name: "date", sortable: false },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        site: {
          title: "Сайт продукта",
          type: "text",
        },
        productCategory: {
          title: "Категория",
          type: "reference",
          resource: "product-categories",
        },
        trademark: {
          title: "Торговая марка",
          type: "reference",
          resource: "trademarks",
        },
        manufacturer: {
          title: "Производитель",
          type: "reference",
          resource: "manufacturers",
        },
        nomenclature: {
          title: "Номеклатура",
          type: "reference",
          resource: "nomenclatures",
        },
        country: {
          title: "Страна происхождения",
          type: "reference",
          resource: "countries",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        weightNetto: {
          title: "Вес нетто",
          type: "decimal",
        },
        unit: {
          title: "Единица измерения",
          type: "reference",
          resource: "units",
        },
        material: {
          title: "Материал",
          type: "text",
        },
        dimensions: {
          title: "Размеры",
          type: "text",
        },
        date: {
          title: "Дата создания",
          type: "date",
        },
      },
    };
  },
};
</script>
